// extracted by mini-css-extract-plugin
module.exports = {"DetailPartsItinerary":"Itinerary_DetailPartsItinerary___puW3","DetailPartsItineraryIcon":"Itinerary_DetailPartsItineraryIcon___eLdh"};